<template>
  <div class="circle-single">
    <div
      class="circle-content circle-content--default circle-base__content--shadow summary-result fade-in"
    >
      <div class="summary-result__wrap">
        <div class="summary-result__content">
          <div
            class="summary-result__item"
            v-for="(value, label) in data.formData"
            :key="label"
          >
            <div class="summary-result__label">
              {{ $t(`${label}.step`) }}
            </div>
            <div class="summary-result__value">
              {{ printValue(value, label) }}
            </div>
          </div>
        </div>
      </div>
      <div class="circle-content__title summary-result__title fade-in">
        {{ $t('summary.title') }}
      </div>
    </div>
  </div>
</template>

<script>
import Circle from '@/class/Circle';
import { Steps } from '@/models/steps';

export default {
  methods: {
    printValue(value, label) {
      if (!value) return;
      if (label === 'label') return value;
      else return typeof value === 'object' ? value.map(v => this.$t(v)).join(', ') : this.$t(value);
    },
  },
  computed: {
    data() {
      return this.$store.getters.getResult;
    },
  },
};
</script>

<style lang="scss">
.summary-result {
  &::before {
    content: '';
    display: block;
    position: absolute;

    bottom: 0;
    left: 0;
    right: 0;

    height: 400px;

    background: radial-gradient(
      ellipse at bottom,
      $brownMedium 40%,
      rgba($brownMedium, 0) 70%
    );

    z-index: 0;

    pointer-events: none;
  }
}

.summary-result__wrap {
  position: absolute;
  top: 10%;
  width: 80%;
  height: 80%;
  overflow: hidden;

  border: 4px solid white;
  border-radius: 50%;
  box-shadow: inset 0 0 100px $brownMedium;
}

.summary-result__content {
  padding: 12.5vw 50px 100px;
  margin: -20px;
  height: 40%;

  overflow: auto;
}

.summary-result__item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.summary-result__label,
.summary-result__value {
  flex-basis: 50%;
  padding: 10px 5px;
  font-size: 1.75em;
  line-height: 1;
  font-weight: bold;
}

.summary-result__label {
  text-align: right;
  color: white;
  text-transform: uppercase;
  padding-left: 0;
}

.summary-result__value {
  text-align: left;
  color: black;
}

@media (min-width: 460.89px) {
  .summary-result__content {
    padding: 80px 50px 100px;
  }
}
@media (min-width: 992.89px) {
  .summary-result__label,
  .summary-result__value {
    font-size: 2em;
  }
}
</style>
